import { inventoryRuleConditionsSchema } from "@redotech/redo-inventory-common/inventory-rules/conditions";
import * as z from "zod";

const processingStateSchema = z.enum([
  "awaiting_processing",
  "no_processing_required",
  "in_processing",
  "processed",
]);

const phaseSchema = z.enum([
  "before_processing",
  "after_processing",
  "in_processing",
]);

const draftDestinationSchema = z.object({
  id: z.string(),
  name: z.string(),
  conditions: inventoryRuleConditionsSchema,
});

export const getSortDestinationCoverage = {
  name: "getSortDestinationCoverage" as const,
  input: z.object({
    /** Draft order, lowest priority first. Omitted reads the saved list. */
    destinations: z.array(draftDestinationSchema).optional(),
    includeCounts: z.boolean().optional(),
  }),
  output: z.object({
    shadowed: z.array(
      z.object({
        destinationId: z.string(),
        destinationName: z.string(),
        blockedByDestinationId: z.string(),
        blockedByName: z.string(),
        merchantAccountId: z.string(),
        processingState: processingStateSchema,
      }),
    ),
    partial: z.array(
      z.object({
        destinationId: z.string(),
        destinationName: z.string(),
        takenByDestinationId: z.string(),
        takenByName: z.string(),
        merchantAccountId: z.string(),
        processingState: processingStateSchema,
      }),
    ),
    unmatched: z.array(
      z.object({
        merchantAccountId: z.string(),
        processingState: processingStateSchema,
        phase: phaseSchema,
        entire: z.boolean(),
      }),
    ),
    truncated: z.boolean(),
    counts: z
      .array(z.object({ destinationId: z.string(), count: z.number().int() }))
      .nullable(),
    unmatchedCount: z.number().int().nullable(),
  }),
};
